import React from 'react'
import V4PModelZoo from '../components/V4PModelZoo/V4PModelZoo'

const V4PModelZooPage = () => {
  return (
    <div>
      <V4PModelZoo/>
    </div>
  )
}

export default V4PModelZooPage